import { IAmendmentResponse } from '../../../../../model/sge/amendment/response/amendment-response';
import { ICommitmentResponse } from '../../../../../model/sge/commitment/response/commitment-response';
import { ILiquidationResponse } from '../../../../../model/sge/liquidation/response/liquidation-response';
import { IPaymentResponse } from '../../../../../model/sge/payment/response/payment-response';
import { ITransferResponse } from '../../../../../model/sge/transfer/response/transfer-response';
import { IAccountReportResponse } from '../../../../../model/sge/account-report/response/account-report-response';
import { IAttachmentResponse } from '../../../../../model/sge/attachment/response/attachment-response';
import { IParlamentarianPagedResponse } from '../../../../../model/sge/parlamentarian/response/parlamentarian-paged-response';
import { IPoliticalPartyPagedResponse } from '../../../../../model/sge/political-party/response/political-party-paged-response';
import { ISupplierPagedResponse } from '../../../../../model/sge/supplier/response/supplier-paged-response';

export type DrawerState<TRecord> = { open: boolean; record?: TRecord };

export type AmendmentDetailState = {
    amendmentId: string;
    amendment?: IAmendmentResponse;
    parlamentarians: IParlamentarianPagedResponse[];
    politicalParties: IPoliticalPartyPagedResponse[];
    suppliers: ISupplierPagedResponse[];
    tabIndex: number;
    commitments: ICommitmentResponse[];
    selectedCommitment?: ICommitmentResponse;
    liquidations: ILiquidationResponse[];
    expandedLiquidationId?: number;
    payments: IPaymentResponse[];
    transfers: ITransferResponse[];
    accountReports: IAccountReportResponse[];
    attachments: IAttachmentResponse[];
    commitmentDrawer: DrawerState<ICommitmentResponse>;
    liquidationDrawer: DrawerState<ILiquidationResponse>;
    paymentDrawer: DrawerState<IPaymentResponse> & { liquidation?: ILiquidationResponse };
    transferDrawer: DrawerState<ITransferResponse>;
    accountReportDrawer: DrawerState<IAccountReportResponse> & { attachments: IAttachmentResponse[] };
};

export type DrawerName = 'commitmentDrawer' | 'liquidationDrawer' | 'paymentDrawer' | 'transferDrawer' | 'accountReportDrawer';

export enum ACTION_TYPES {
    setLookups = 'setLookups',
    setAmendment = 'setAmendment',
    setTabIndex = 'setTabIndex',
    setCommitments = 'setCommitments',
    setSelectedCommitment = 'setSelectedCommitment',
    setLiquidations = 'setLiquidations',
    setExpandedLiquidationId = 'setExpandedLiquidationId',
    setPayments = 'setPayments',
    setTransfers = 'setTransfers',
    setAccountReports = 'setAccountReports',
    setAttachments = 'setAttachments',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
    setAccountReportAttachments = 'setAccountReportAttachments',
}

const closedDrawers = {
    commitmentDrawer: { open: false },
    liquidationDrawer: { open: false },
    paymentDrawer: { open: false },
    transferDrawer: { open: false },
    accountReportDrawer: { open: false, attachments: [] },
};

export const initialDrawers = closedDrawers;

export const AmendmentDetailReducer = (state: AmendmentDetailState, action: any): AmendmentDetailState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setLookups: return { ...state, ...payload };
        case ACTION_TYPES.setAmendment: return { ...state, amendment: payload };
        case ACTION_TYPES.setTabIndex: return { ...state, tabIndex: payload };
        case ACTION_TYPES.setCommitments: return { ...state, commitments: payload };
        // Trocar de empenho fecha a liquidação expandida e limpa os níveis abaixo
        case ACTION_TYPES.setSelectedCommitment: return { ...state, selectedCommitment: payload, liquidations: [], expandedLiquidationId: undefined, payments: [] };
        case ACTION_TYPES.setLiquidations: return { ...state, liquidations: payload };
        case ACTION_TYPES.setExpandedLiquidationId: return { ...state, expandedLiquidationId: payload, payments: [] };
        case ACTION_TYPES.setPayments: return { ...state, payments: payload };
        case ACTION_TYPES.setTransfers: return { ...state, transfers: payload };
        case ACTION_TYPES.setAccountReports: return { ...state, accountReports: payload };
        case ACTION_TYPES.setAttachments: return { ...state, attachments: payload };
        case ACTION_TYPES.openDrawer: {
            const { name, ...drawer } = payload as { name: DrawerName };
            return { ...state, [name]: { ...closedDrawers[name], ...drawer, open: true } };
        }
        case ACTION_TYPES.closeDrawer: return { ...state, [payload as DrawerName]: closedDrawers[payload as DrawerName] };
        case ACTION_TYPES.setAccountReportAttachments: return { ...state, accountReportDrawer: { ...state.accountReportDrawer, attachments: payload } };
        default: throw new Error(`Unhandled action type: ${type}`);
    }
};
